var React = require('react');

function Accelerate (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"fill":"#12EBAE","d":"M-371.9,262.8l-36.8-36.8c-1.5-1.5-4.1-1.5-5.6,0l0,0c-1.5,1.5-1.5,4.1,0,5.6l36.4,36.4l-36.4,36.4\n\t\t\t\tc-1.5,1.5-1.5,4.1,0,5.6l0,0c1.5,1.5,4.1,1.5,5.6,0l36.8-36.8C-369,270.3-369,265.7-371.9,262.8z","key":0}),React.createElement("path",{"fill":"#12EBAE","d":"M-344.7,262.8l-36.8-36.8c-1.5-1.5-4.1-1.5-5.6,0l0,0c-1.5,1.5-1.5,4.1,0,5.6l36.4,36.4l-36.4,36.4\n\t\t\t\tc-1.5,1.5-1.5,4.1,0,5.6l0,0c1.5,1.5,4.1,1.5,5.6,0l36.8-36.8C-341.8,270.3-341.8,265.7-344.7,262.8z","key":1})])));
}

Accelerate.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"-415.4 224.9 72.9 86.3","enableBackground":"new -415.4 224.9 72.9 86.3","xmlSpace":"preserve","height":"72px"};

module.exports = Accelerate;

Accelerate.default = Accelerate;
